export default __webpack_public_path__ + "static/media/arrow_back.de0e2b29.svg";